/*=========================================================================================
  File Name: moduleImmoActions.js
  Description: Immo Module Actions
==========================================================================================*/


export default {
  SetSearchParams({
    commit
  }, payload) {
    commit('SET_SEARCH_PARAMS', payload);
  },
  SetIsBackToSearch({
    commit
  }, payload) {
    commit('SET_ISBACK_TOSEARCH', payload);
  },
};